// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Models
import {
    Homeroom, Campus, CampusFullItem,
    Schoolyear, YearLevel, Semester, Term, Season
} from '../models/Catalog';
// Services
import { ApiService } from './ApiService';
import { SettingService } from './SettingService';
import { FileService } from './FileService';

@Injectable()

export class CatalogService {
    private fullCampusUrl = '/included-campuses';
    private campusUrl = '/campuses';
    private homeroomUrl = '/homerooms';
    private schoolyearUrl = '/school-years';
    private yearLevelUrl = '/year-levels';
    private semesterUrl = '/semesters';
    private termUrl = '/asa-terms';
    private currentSeasonUrl = '/seasons/currents';
    private allCurrentSeasonUrl = '/seasons/currents/all';
    private seasonUrl = '/seasons';

    private apiUrl = '';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService,
        private fileService: FileService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    /**
     * Get campus items
     * @returns {Observable<Campus[]>} Array list of Campus class
     */
    getCampuses(): Observable<Campus[]> {
        const requestUrl = this.apiUrl + this.campusUrl;

        return this.apiService.get<Campus[]>(requestUrl);
    }

    /**
     * Get full campus item with contain yearlevels and homerooms.
     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
     */
    getCampusesFullItems(): Observable<CampusFullItem[]> {
        const requestUrl = this.apiUrl + this.fullCampusUrl;

        return this.apiService.get<CampusFullItem[]>(requestUrl);
    }

    /**
     * Get homerooms
     * @returns {Observable<Homeroom[]>} Array list of Homeroom class
     */
    getHomerooms(): Observable<Homeroom[]> {
        const requestUrl = this.apiUrl + this.homeroomUrl;

        return this.apiService.get<Homeroom[]>(requestUrl);
    }

    /**
     * Get school years
     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
     */
    getSchoolyears(): Observable<Schoolyear[]> {
        const requestUrl = this.apiUrl + this.schoolyearUrl;

        return this.apiService.get<Schoolyear[]>(requestUrl);
    }

    /**
     * Get year levels
     * @returns {Observable<YearLevel[]>} Array list of YearLevel class
     */
    getYearLevels(): Observable<YearLevel[]> {
        const requestUrl = this.apiUrl + this.yearLevelUrl;

        return this.apiService.get<YearLevel[]>(requestUrl);
    }

    getSemesters(): Observable<Semester[]> {
        const requestUrl = this.apiUrl + this.semesterUrl;

        return this.apiService.get<Semester[]>(requestUrl);
    }

    getTerms(): Observable<Term[]> {
        const requestUrl = this.apiUrl + this.termUrl;

        return this.apiService.get<Term[]>(requestUrl);
    }

    getSeason(): Observable<Season[]> {
        const requestUrl = this.apiUrl + this.seasonUrl;

        return this.apiService.get<Season[]>(requestUrl);
    }

    getCurrentSeason(): Observable<Season> {
        const requestUrl = this.apiUrl + this.currentSeasonUrl;

        return this.apiService.get<Season>(requestUrl);
    }

    getAllCurrentSeason(): Observable<Season[]> {
        const requestUrl = this.apiUrl + this.allCurrentSeasonUrl;

        return this.apiService.get<Season[]>(requestUrl);
    }

    getTermBySemesterId(semesterId: any): Observable<Term[]> {
        const requestUrl = this.apiUrl + this.termUrl + '?semester_id=' + semesterId;

        return this.apiService.get<Term[]>(requestUrl);
    }

    getTemrmByCurrentSemester(): Observable<Term[]> {
        return this.getSemesters()
            .map(semesterList => _.filter(semesterList, function (o) { return o.is_current; })[0].id)
            .switchMap(currentSemesterId => currentSemesterId ? this.getTermBySemesterId(currentSemesterId) : Observable.of(null));
    }

    /**
     * Handle Promise errors
     * @returns {String} Message error
     */
    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/CatalogService.ts